import { DeliveryMenuScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <DeliveryMenuScreen />;
}
